import FirestoreModel from './FirestoreModel'
import { required, string } from 'vue-mc/validation'

export default class Attachment extends FirestoreModel {
  modelName = 'Attachment'
  collection = 'attachments'
  autoFields = true

  defaults () {
    return {
      id: null,
      title: null,
      path: null,
      downloadURL: null,
      organization: null,
      project: null
    }
  }

  validation () {
    return {
      title: required.and(string),
      path: string,
      downloadURL: string,
      organization: string,
      project: string
    }
  }
}
